module.exports = __webpack_public_path__ + "img/bg.f995e371.jpg";